export const PUBLIC_ROUTE = {
  LANDING: '',
  PAGE_404: '404',
  PAGE_500: '500',
  ONBOARDING: 'onboarding',
  LOGIN: 'login',
  REGISTER: 'register',
  PASSWORD_LOGIN: 'password-login',
  FORGOT_PASSWORD: 'forgot-password',
  OTP_VERIFY: 'otp-verify',
  CREATE_PASSWORD: 'create-password',
  RESET_PASSWORD: 'reset-password',
  EMAIL_REGISTER: 'email-register',
  HOME: 'home',
  POPULAR: 'popular',
  GAMES: 'games',
  CHILD_GAMES: 'child-games',
  MESSAGE: 'message',
  NOTIFICATION: 'notification',
  NOTIFICATION_DETAILS: 'notification-details',
  PROFILE: 'profile',
  TOP_WINNERS: 'top-winners',
  FRIEND_LIST: 'friend-list',
  CHANGE_PIN: 'change-pin',
  INVITE_LINK: 'invite-link',
  EDIT_PROFILE: 'edit-profile',
  POCKET_MONEY: 'pocket-money',
  POCKET_MONEY_CONFIRM_PIN: 'pocket-money-confirm-pin',
  SPIN_HOME: 'spin-home',
  SPIN_HISTORY: 'spin-history',
  SPIN_RULE: 'spin-rule',
  SEARCH: 'search',
  APP_DOWNLOAD: 'app-download',
  VIEW_SHARED_LINK: 'view-shared-link',
  PROMO_REGISTER: 'promo-register',
};

export const PRIVATE_ROUTE = {
  IN_GAME: 'in-game',
  WALLET: 'wallet',
  TRANSACTIONS: 'transactions',
  ACCOUNT_TYPE: 'account-type',
  FILL_AMOUNT: 'fill-amount',
  PROCEED_TOPUP: 'proceed-topup',
  WITHDRAW_ACCOUNTS: 'withdraw-accounts',
  CREATE_UPDATE_ACCOUNT: 'create-update-account',
  CONFIRM_PIN: 'confirm-pin',
  SHARE_LIST: 'share-list',
  SHARE_RULES: 'share-rules',
  SHARE_HISTORY: 'share-history',
  SHARE_LINK: 'share-link',
  PROMO_CODE_HISTORY: 'promo-code-history',
  PROMO_TERMS: 'promo-terms',
  GAME_LOST_REQUEST: 'game-lost-request',
  GAME_LOST_REQUEST_HISTORY: 'game-lost-request-history',
  FREEZE_BALANCES: 'freeze-balances',
  CHECK_PAYMENT_DATA: 'check-payment-data',
};
